@if ($isOnlyFeature()) {
<header class="feature-header">
  <h3 [innerHtml]="$content().name"></h3>
</header>
}
<div class="control">
  <input
    type="search"
    id="contacts-search"
    placeholder="Search for a ONEOK contact"
    (input)="onSearch( $any($event) )"
  />
</div>
<div>
  <table class="contacts-table">
    <tbody>
      @for (contact of templateContacts; track contact; let contactIdx = $index) {
      <tr>
        @for (column of columnsKey; track column; let columnIdx = $index) { @if (column.key === 'area') {
        <td>
          @if (contact['area'] === null || contact['area'] === '') { {{ contact['group'] || "" }} } @else { {{
          contact['area'] || "" }} - {{ contact['group'] || "" }} }
        </td>
        } @if (column.key !== 'area' && column.key !== 'group') {
        <td>
          @if (column.key === 'email') {
          <a [href]="'mailto:' + contact[ column.key ]">
            <span class="text">{{ contact[ column.key ] }}</span>
            <svg-icon class="icon" src="/assets/svg/circle-envelope.svg" />
          </a>
          } @if (column.key === 'phoneOffice' || column.key === 'phoneMobile') { {{ (contact[column.key]?.toString() ??
          '') | prettyPhone }} } @if (!['email', 'phoneOffice', 'phoneMobile'].includes(column.key)) { {{ contact[
          column.key ] || "" }} }
        </td>
        } }
      </tr>
      }
    </tbody>
    <thead>
      <tr>
        @for (column of columnsKey; track column; let columnIdx = $index) { @if (column.key === 'area') {
        <th>Area-Group</th>
        } @if (column.key !== 'area' && column.key !== 'group') {
        <th>{{ column.label }}</th>
        } }
      </tr>
    </thead>
  </table>
</div>
